import { Component, ChangeDetectionStrategy, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { NavItem } from './nav-config';
import { HasCapabilityDirective } from '../shared/directives/has-capability.directive';

@Component({
  selector: 'app-nav-mobile-group',
  standalone: true,
  imports: [RouterModule, TranslateModule, FontAwesomeModule, HasCapabilityDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button class="flex items-center justify-between w-full py-2 hover:text-mty-primary transition-colors cursor-pointer"
            (click)="open.set(!open())">
      <span>{{ item().labelKey | translate }}</span>
      <fa-icon [icon]="faChevronDown"
               class="text-xs transition-transform"
               [class.rotate-180]="open()"></fa-icon>
    </button>
    @if (open()) {
      <div class="pl-4 pb-1">
        @for (child of item().children; track child.labelKey) {
          <ng-container *appHasCapability="child.capability">
            @if (child.externalUrl) {
              <a class="block py-2 hover:text-mty-primary transition-colors"
                 [href]="child.externalUrl" target="_blank" rel="noopener noreferrer"
                 (click)="navigate.emit()">
                {{ child.labelKey | translate }}
              </a>
            } @else {
              <a class="block py-2 hover:text-mty-primary transition-colors"
                 [routerLink]="resolveRoute()(child)"
                 [queryParams]="child.queryParams"
                 (click)="navigate.emit()">
                {{ child.labelKey | translate }}
              </a>
            }
          </ng-container>
        }
      </div>
    }
  `,
})
export class NavMobileGroupComponent {
  readonly item = input.required<NavItem>();
  readonly resolveRoute = input.required<(item: NavItem) => string>();
  readonly navigate = output<void>();
  readonly open = signal(false);
  faChevronDown = faChevronDown;
}
